import { environmentBucket } from '@/settings/environment.utils';
import { http } from '@pendo/http';

export async function getFileFromCDN (relativePath) {
    return http
        .get(`https://${environmentBucket(true)}${relativePath}`, {
            withCredentials: false,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function buildCdnImageUrl (path) {
    return `https://${environmentBucket(true)}${path}`;
}

export async function getFileFromCDNWithFallback (relativePath, fallbackPath) {
    let file = null;
    try {
        file = await getFileFromCDN(relativePath);
    } catch {
        file = await getFileFromCDN(fallbackPath);
    }

    return file;
}
